import { useContext } from 'react';
import leaderboardContext from './leaderboardContext';

const useLeaderboadState = () => {
    const context = useContext(leaderboardContext);

    if (!Object.keys(context).length) {
        throw new Error('LeaderboardContext must be used within its provider');
    }

    return context;
};

export default useLeaderboadState;
